/**
 * Warning: this is a PARTIAL copy of "abcstrategie/cogaa" project's file.
 * Each update of the main project should be manually made.
 */
import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'

import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {auth},
  plugins: [createPersistedState({storage: window.localStorage})]
})



// WEBPACK FOOTER //
// ./src/store/index.js